import { Action, ActionDropdown } from 'components';
import { ReactNode } from 'react';
import { usePlanMeta, usePlanMutations } from '../state';
import { getSingleCreatedItem } from '../state/helpers';

export function AddRowButton(): ReactNode {
  const { locked, planning } = usePlanMeta();
  const { addRow, update, selectCell } = usePlanMutations();
  if (locked) {
    return null;
  }

  const actions: (Action | '-')[] = [
    {
      action: 'add-media',
      button: {
        icon: 'rectangle-ad',
        children: 'Media',
        onClick: () => addRow('MEDIA'),
        disabled: !planning,
      },
    },
    {
      action: 'add-service',
      button: {
        icon: 'screwdriver-wrench',
        children: 'Service',
        onClick: () => addRow('SERVICE'),
        disabled: !planning,
      },
    },
    {
      action: 'add-smart',
      button: {
        icon: 'wand-magic-sparkles',
        children: 'Smart service',
        onClick: () => addRow('SMART'),
        disabled: !planning,
      },
    },
    '-',
    {
      action: 'add-group',
      button: {
        icon: 'folder',
        children: 'Add group',
        onClick: async () => {
          const res = await update(
            {
              groups: { upsert: [{ title: '', budget: null, parent_id: null }] },
            },
            (resp, prevState) => getSingleCreatedItem('groups', resp, prevState),
          );
          const group = res.unwrap();
          selectCell(`group-${group.id}`);
        },
        disabled: false, // can add row unless locked
      },
    },
  ];
  return (
    <ActionDropdown actions={actions} variant="primary" size="sm" icon="plus" testId="add-row">
      Add row
    </ActionDropdown>
  );
}
